import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CommonOptions} from 'src/app/core/interfaces/interfaces';
import {CommonService} from 'src/app/core/services/modules/common.service';
import {DialogService} from 'src/app/core/services/utils/dialog.service';
import {environment} from 'src/environments/environment';
import {VehicleService} from '../../../services/modules/vehicle.service';
import {FechasService} from 'src/app/core/services/utils/fechas.service';
import {HttpErrorResponse} from '@angular/common/http';
import {SnackBarService} from 'src/app/core/services/utils/snackBar.service';
import {Router} from '@angular/router';
import {CommonMetodService} from 'src/app/core/services/utils/commonMetod.service';
import {AuthGuardService} from '../../../services/guards/AuthGuardService';

export interface DialogData {
  CompanyInfoId: string;
}

@Component({
  selector: 'app-dialog-create-vehicle',
  templateUrl: './dialog-create-vehicle.component.html',
  styleUrls: ['./dialog-create-vehicle.component.scss']
})
export class DialogCreateVehicleComponent implements OnInit {
  s3Bucket: string;
  documentType = 'PLACA';
  imgCropperResult: string;

  readonly vehicleDocumentTypes = [
    { Value: 'PLACA',               Description: 'PLACA' },
    { Value: 'REGISTRO_MAQUINARIA', Description: 'REGISTRO DE MAQUINARIA' },
  ];

  form: FormGroup;
  formDataPhoto: FormData;
  next = false;
  documentNumber = '';
  flagCreateVehicle = false;
  flagExitContractContracts = true;

  proyects: any[] = [];
  vehicleContracts: any[] = [];
  proyectSelected: any [] = [];
  personalSelected: any [] = [];
  contractsSelected: any [] = [];
  vehicleContractsFilter: any[] = [];
  selectedVehicleContracts: any[] = [];

  contries: CommonOptions[] = [];
  vehicleTypeAll: CommonOptions[] = [];
  vehicleTypeFiltered: CommonOptions[] = [];
  machineryTypeAll: CommonOptions[] = [];

  permissionsCompany: string[] = [];

  date = new Date();
  controlEmployer = new FormControl();
  controlContractSelected = new FormControl();
  minDateVigenciaContract = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate());

  constructor(public dialogRef: MatDialogRef<DialogCreateVehicleComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              private commonService: CommonService,
              private authService: AuthGuardService,
              private dialogService: DialogService,
              private vehicleService: VehicleService,
              private fechasService: FechasService,
              private snackBService: SnackBarService,
              private router: Router,
              private fb: FormBuilder,
              public commonMetodService: CommonMetodService) {
      this.form = this.fb.group({
        Photo: new FormControl(''),
        LicenseSearch: new FormControl('', Validators.required),
        LicenseNumbersearch: new FormControl(''),
        License: new FormControl('', Validators.required),
        LicenseNumber: new FormControl(''),
        Review: new FormControl(''),
        CountryId: new FormControl('', Validators.required),
        VehicleTypeId: new FormControl('', Validators.required),
        // DAtOS DEL CONTRACTO
        FinishDate: new FormControl('', Validators.required),
        StartDate: new FormControl(this.fechasService.getDateFormatDatePikerDATEHORANOW(), Validators.required),
        Function: new FormControl('', Validators.required),
        ContractId: new FormControl('', Validators.required),
      });

      this.permissionsCompany = this.authService.auth.getUser().Companies.find(x => x.Id === this.data.CompanyInfoId).Permissions;

      this.commonService.getCommonOptions('Country').subscribe((data: CommonOptions[]) => {
        this.contries = data.sort((a, b) => a.OrderNum > b.OrderNum ? 1 : -1);
      });
      this.commonService.getCommonOptions('VehicleType').subscribe((data: CommonOptions[]) => {
          this.vehicleTypeAll = data.sort((a, b) => a.OrderNum > b.OrderNum ? 1 : -1);
          this.vehicleTypeFiltered = [...this.vehicleTypeAll];
      });
      this.commonService.getCommonOptions('MachineryType').subscribe((data: CommonOptions[]) => {
          this.machineryTypeAll = data.sort((a, b) => a.OrderNum > b.OrderNum ? 1 : -1);
      });

      this.commonService.getContract().subscribe((contracts: any[]) => {
        this.vehicleContracts = contracts.filter(x => x.IsActive === true);
      });
  }

  ngOnInit(): void {
    this.s3Bucket = environment.api.s3Bucket;
    setTimeout(() => {
      this.commonService.getProyect().subscribe((proyects: any[]) => {
        this.proyects = proyects.filter(proy => proy.CompanyInfoId === this.data.CompanyInfoId && proy.IsActive === true);
        if (this.proyects.length === 1) {
          this.proyectSelected.push(this.proyects[0]);
          this.selectedProyect(this.proyects[0].Id);
        }
      });
    }, 300);
  }

  setValue() {
    if (this.controlEmployer.value !== undefined) {
      this.controlEmployer.setValue('');
      this.controlContractSelected.setValue('');
      this.proyectSelected = [];
      this.personalSelected = [];
      this.contractsSelected = [];
      this.documentNumber = '';
      this.flagExitContractContracts = true;
      this.onDocumentTypeChange('PLACA');
    }
  }

  onDocumentTypeChange(docType: string): void {
    this.documentType = docType;
    this.form.get('LicenseSearch').setValue('');
    this.form.get('LicenseNumbersearch').setValue('');

    if (docType === 'PLACA') {
      this.form.get('LicenseSearch').enable();
      this.form.get('License').enable();
      this.form.get('LicenseSearch').setValidators([Validators.required]);
      this.form.get('License').setValidators([Validators.required]);
    } else {
      this.form.get('LicenseSearch').clearValidators();
      this.form.get('License').clearValidators();
      this.form.get('LicenseSearch').disable();
      this.form.get('License').disable();
    }
    this.form.get('LicenseSearch').updateValueAndValidity();
    this.form.get('License').updateValueAndValidity();
  }

  clearLicenseNumberSearch(): void {
    this.form.get('LicenseNumbersearch').setValue('');
  }

  selectedProyect(Id: any) {
    this.proyectSelected = [];
    const data = this.proyects.find(x => x.Id === Id);
    this.proyectSelected.push(data);
    this.vehicleContractsFilter = [];
    this.isFromVehicleContractsPermission(this.vehicleContracts);
  }

  isFromVehicleContractsPermission(contracts) {
    contracts.forEach(contract => {
      if (contract.IsActive === true && contract.ProjectIds.includes(this.proyectSelected[0].Id)) {
        if (this.exitPermissionCompany('vehiclesad.add') && contract.ValueContractType === 'AD') {
          this.vehicleContractsFilter.push(contract);
        } else if (this.exitPermissionCompany('vehiclesco.add') && contract.ValueContractType === 'CO') {
          this.vehicleContractsFilter.push(contract);
        } else if (this.exitPermissionCompany('vehiclesas.add') && contract.ValueContractType === 'AS') {
          this.vehicleContractsFilter.push(contract);
        } else if (this.exitPermissionCompany('vehiclesfu.add') && contract.ValueContractType === 'FU') {
          this.vehicleContractsFilter.push(contract);
        } else if (this.exitPermissionCompany('vehiclesvi.add') && contract.ValueContractType === 'VI') {
          this.vehicleContractsFilter.push(contract);
        } else if (this.exitPermissionCompany('personalspr.add') && contract.ValueContractType === 'PR') {
          this.vehicleContractsFilter.push(contract);
        } else if (this.exitPermissionCompany('vehiclesot.add') && contract.ValueContractType === 'OT') {
          this.vehicleContractsFilter.push(contract);
        }
      }
    });
  }

  getVehicleDocument() {
    if (this.selectedVehicleContracts.length === 0) {
      this.snackBService.openWarning('Seleccionar contrato antes de continuar.', '', 4000);
    } else {
      const isPlaca = this.documentType === 'PLACA';
      const invalidPlaca = isPlaca && (this.form.get('LicenseSearch').value || '').trim().length !== 6;
      const invalidRegistro = !isPlaca && (this.form.get('LicenseNumbersearch').value || '').trim().length === 0;

      if (invalidPlaca || invalidRegistro) {
        this.snackBService.openWarning('Verifique la información ingresada.', '', 4000);
      } else {
        const docNum = isPlaca
          ? (this.form.get('LicenseSearch').value || '').toString().toUpperCase()
          : (this.form.get('LicenseNumbersearch').value || '').toString().toUpperCase();

        this.vehicleService.getVehicleDocNumContractId(
          docNum,
          this.selectedVehicleContracts[0].Id).subscribe((data: any) => {
          const vehicleCompany = {
            FinishDate: this.form.get('FinishDate').value,
            StartDate: this.form.get('StartDate').value,
            Function: this.form.get('Function').value,
            ContractId: this.form.get('ContractId').value,
            VehicleCompanyInfoId: data?.VehicleInfoId
          };
          if (data !== null) {
            this.vehicleService.getIsContractVehicleCompanyInfoId(this.selectedVehicleContracts[0].Id,
              data.VehicleInfoId).subscribe(isContract => {
              this.vehicleService.postVehicleContract(vehicleCompany).subscribe((restContractPersonal: any) => {
                this.router.navigate(['/admin/vehicle/vehicle/', data?.VehicleInfoId]);
                this.dialogRef.close(true);
              });
            }, (error: HttpErrorResponse) => {
              if (error.status === 400){
                this.dialogService.openDialogMovePersonalInfo(true, error, 'Desea trasladarlo?',
                  false, 'TRANSLADAR VEHICULO').afterClosed().subscribe(restDialog => {
                  if (restDialog === true) {
                    this.vehicleService.postMoveVehicleInfoContract(
                      this.selectedVehicleContracts[0].Id, vehicleCompany).subscribe((restMOvePersonal: any) => {
                      this.router.navigate(['/admin/vehicle/vehicle/', data.VehicleInfoId]);
                      this.dialogRef.close(true);
                    });
                  }
                });
              }
          });
          }
        }, (error: HttpErrorResponse) => {
          error.status === 400 || error.status === 404 || error.status === 409 ?
            this.dialogService.openDialogConfirm(
              `Lo sentimos, no hay un vehiculo registrado con este número. Desea crearlo?`).afterClosed().subscribe(rest => {
              if (rest !== false) {
                this.flagCreateVehicle = true;
                this.form.get('CountryId').setValue('0');
                if (isPlaca) {
                  this.form.get('License').setValue(this.form.get('LicenseSearch').value.toUpperCase());
                  this.form.get('License').disable();
                  this.applyVehicleTypeFilter(this.form.get('License').value?.substring(0, 3));
                } else {
                  this.form.get('LicenseNumber').setValue(this.form.get('LicenseNumbersearch').value.toUpperCase());
                  this.form.get('LicenseNumber').disable();
                  this.vehicleTypeFiltered = this.machineryTypeAll.length > 0 ? [...this.machineryTypeAll] : [...this.vehicleTypeAll];
                }
              }
            })
          : '';
        });
      }
    }
  }

  getImg(logo: string) {
    return (logo === null || logo === '' || logo === undefined ? this.s3Bucket + 'assets/images/gnr-buildings.png' : this.s3Bucket + logo);
  }

  getImgContract(logo: string) {
    return (logo === null || logo === '' || logo === undefined ?
      'upload/images/form-images/file_235c080f-43b7-42c6-bd43-0af779cdb223.svg' : logo);
  }

  close() {
    this.dialogRef.close(false);
  }

  save() {
    if (this.form.status === 'VALID')  {
      const license = this.documentType === 'REGISTRO_MAQUINARIA'
        ? (this.form.get('LicenseNumber').value || '').toUpperCase()
        : (this.form.get('License').value || '').toUpperCase();

      const model = {
        License: license,
        DocumentType: this.documentType,
        CountryId: parseInt(this.form.get('CountryId').value, 10) || 0,
        Review: this.form.get('Review').value,

        CompanyInfoId: this.data?.CompanyInfoId,
        VehicleTypeId: this.form.get('VehicleTypeId').value,
        Photo: '',
      };
      this.vehicleService.postVehicle(model).subscribe((restCreate: any) => {
        const modelAsociaContractVehicle = {
          FinishDate: this.form.get('FinishDate').value,
          StartDate: this.form.get('StartDate').value,
          Function: this.form.get('Function').value,
          ContractId: this.form.get('ContractId').value,
          VehicleCompanyInfoId: restCreate?.Id
        };
        if (this.formDataPhoto === undefined) {
          this.vehicleService.postVehicleContract(modelAsociaContractVehicle).subscribe(restAsociate => {
            this.dialogRef.close(restCreate.Id);
            this.router.navigate(['/admin/vehicle/vehicle/', restCreate.Id]);
          });
        } else {
          this.vehicleService.updatePhotoVehicle(restCreate.Id, this.formDataPhoto).subscribe(rest => {
            this.vehicleService.postVehicleContract(modelAsociaContractVehicle).subscribe(restAsociate => {
              this.dialogRef.close(restCreate.Id);
              this.router.navigate(['/admin/vehicle/vehicle/', restCreate.Id]);
            });
          });
        }

      }, (error: HttpErrorResponse) => {
        error.status === 409 ?
        this.snackBService.openWarning('Ya existe un vehiculo con la placa digitada.', '', 4000) : '';
      }
      );
    } else {
      this.form.markAllAsTouched();
    }
  }

  updatePhotoVehicle() {
    this.dialogService.openDialogGestorImg('CARGAR IMAGEN', [], 'editPhoto', 0, 'true', true).afterClosed().subscribe(formDataPhoto => {
      if (!formDataPhoto) { return; }

      const MAX = 10_000_000;
      const isFormData = (x: any): x is FormData =>
        x && typeof x.append === 'function' && typeof x.get === 'function';

      const original = formDataPhoto?.meta?.originalBytes as number | undefined;
      if (typeof original === 'number' && original > MAX) {
        this.snackBService.openWarning('El archivo supera el peso máximo permitido de 10 MB', '', 5000);
        return;
      }

      const fd: FormData = isFormData(formDataPhoto) ? formDataPhoto : isFormData(formDataPhoto?.FormData) ?
        formDataPhoto.FormData : null;
      if (!fd) { return; }

      const fileOrBlob = fd.get('File') as File | Blob | null;
      if (!fileOrBlob) { return; }

      if (fileOrBlob.size > MAX) {
        this.snackBService.openWarning('El archivo supera el peso máximo permitido de 10 MB', '', 5000);
        return;
      }
      this.imgCropperResult = formDataPhoto.imgResult;
      this.formDataPhoto = formDataPhoto.FormData;
    });
  }

  setValueContract() {
    if (this.controlContractSelected.value !== undefined) {
      this.form.get('ContractId').setValue('');
      this.selectedVehicleContracts = [];
    }
  }

  onSelectionChangeContract(e: any) {
    this.selectedVehicleContracts = [];
    this.vehicleContracts.forEach((contract: any) => {
      if (contract.Id === e) {
        this.selectedVehicleContracts.push(contract);
        this.form.get('FinishDate').setValue(contract.FinishDate);
        this.form.get('Function').setValue(

          contract.DescriptionPersonalType !== null
          ?
            contract?.DescriptionPersonalType?.toUpperCase() === 'OTROS' ?
            'FUNCION DESCONOCIDA' : 'VEHICULO ' + contract?.DescriptionPersonalType?.toUpperCase()
          : 'FUNCION DESCONOCIDA');
      }
    });
  }

  private normalizeText(s: string): string {
    return (s ?? '')
      .toUpperCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // quita tildes
      .trim();
  }

  private applyVehicleTypeFilter(licenseL: string): void {
    const letters = this.normalizeText(licenseL);

    const isBicyclePlate = /^[AB]{3}$/.test(letters);

    if (isBicyclePlate) {
      // SOLO BICICLETA
      this.vehicleTypeFiltered = this.vehicleTypeAll.filter(x =>
        this.normalizeText(x.Description) === 'BICICLETA'
      );
    } else {
      // TODO MENOS BICICLETA
      this.vehicleTypeFiltered = this.vehicleTypeAll.filter(x =>
        this.normalizeText(x.Description) !== 'BICICLETA'
      );
    }

    // Si lo que estaba seleccionado ya no existe en la lista, lo limpio
    const selected = this.form.get('VehicleTypeId')?.value;
    const stillExists = this.vehicleTypeFiltered.some(x => x.Id === selected);
    if (!stillExists) {
      this.form.get('VehicleTypeId')?.setValue('');
    }

    // (Opcional) si es placa de bicicleta, autoselecciona BICICLETA
    if (isBicyclePlate && this.vehicleTypeFiltered.length === 1) {
      this.form.get('VehicleTypeId')?.setValue(this.vehicleTypeFiltered[0].Id);
    }
  }


  exitPermissionCompany(permiso: string): boolean {
    let exit = false;
    const permisionsUserInfo  = this.permissionsCompany.find(x => x === permiso);
    permisionsUserInfo !== undefined ? exit = true : exit = false;
    return exit;
  }
}
